import axiosInstance from "../../utils/axiosCompany";

// export const UpdateDateOfBusiness = async (values) => {
//     return await axiosInstance().post("company/order/update-date-of-business", values);
// }
export const GetTrackingOrders = async (values) => {
    return await axiosInstance().post("company/get-tracking-orders", values);
}

